/**
 * Hook for wrapping native ETH to WETH
 */

import { useWriteContract, useWaitForTransactionReceipt } from 'wagmi'
import { WETHABI } from '@contracts/abis'
import { SUPPORTED_TOKENS } from '@contracts/tokens'

export function useWrapETH() {
  const { writeContract, data: hash, isPending, isError, error } = useWriteContract()

  const { isLoading: isConfirming, isSuccess } = useWaitForTransactionReceipt({
    hash,
  })

  const wrapETH = async (amount: bigint) => {
    try {
      console.log('🟢 [useWrapETH] Wrapping ETH to WETH', {
        amount: amount.toString(),
        wethAddress: SUPPORTED_TOKENS.WETH.address
      })
      
      writeContract({
        address: SUPPORTED_TOKENS.WETH.address,
        abi: WETHABI,
        functionName: 'deposit',
        value: amount, // Send ETH as value
      })
      
      console.log('🟢 [useWrapETH] Wrap transaction submitted')
    } catch (err) {
      console.error('🔴 [useWrapETH] Error:', err)
      throw err
    }
  }

  return {
    wrapETH,
    hash,
    isPending: isPending || isConfirming,
    isSuccess,
    isError,
    error,
  }
}

